import React, { useState, useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { message, Row, Col } from "antd";
import { CardElement } from "../../../../components/Common/UIElements";

import {
  ButtonPrimary,
  Button,
} from "../../../../components/Common/Button/index";
import CustomerDetailsForm from "../../../../components/Onboarding/CustomerDetailsForm/CustomerDetailsForm";
import { onboardingCustomerDetailsSchema } from "../../../../schema/onboarding-customer.schema";
import {
  useGetCustomer,
  useUpdateCustomer,
  useApproveCustomer,
} from "../../../../hooks/Onboarding/onboarding.hooks";

const operation = "approve";

const CustomerContainer = () => {
  const history = useHistory();

  const [customerId, setCustomerId] = useState();

  const { id } = useParams();
  useEffect(() => {
    if (id) {
      setCustomerId(id);
    }
  }, [id]);

  // fetch customer (HMG)
  const { data: apiCustomerData, refetch: refetchCustomerData } =
    useGetCustomer(customerId, {
      enabled: !!customerId,
    });

  const {
    control,
    reset,
    formState,
    setValue,
    getValues,
    watch,
    handleSubmit,
  } = useForm({
    mode: "onChange",
    resolver: yupResolver(onboardingCustomerDetailsSchema),
  });

  useEffect(() => {
    if (apiCustomerData) {
      // remove unrequired fields
      // TODO: filter incoming data and assign accordingly

      reset({
        ...apiCustomerData,
      });
    }
  }, [apiCustomerData]);

  const { mutateAsync: updateCustomer } = useUpdateCustomer({
    onSuccess: () => {
      message.success("Corporate Customer Update in successfully");
    },
    onError: (error) => {
      message.error(error.response?.data?.message ?? "Server Error");
    },
  });

  // approve customer hooks
  const { mutate: approveCustomer, isLoading: updatingApproveCustomer } =
    useApproveCustomer({
      onSuccess: () => {
        // need to invalidate/ refetch customer data
        refetchCustomerData();
        history.push(`/onboarding/customers/${customerId}/approve-property`);
      },
      onError: (error) => {
        message.error(error.response?.data?.message ?? "Server Error");
      },
    });

  // approve customer (HMG) detail
  const formSubmit = async (formData) => {
    let result = await updateCustomer(formData);
    if (result?.updatedCustomer?._id) {
      // TODO: trigger approve after customer update. approveCustomer is working. functionality dev tested

      approveCustomer({ _id: result?.updatedCustomer?._id });
    }
  };

  return (
    <CardElement title="System Discovery">
      <Row>
        <Col span={24}>
          <div className="card-header">
            Let's set up Your Hotel Management Group
          </div>
          <div className="card-sub-header">
            Your data has already been entered. Please update if anything is
            missing and click on "Approve HMG"
          </div>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <CustomerDetailsForm
            control={control}
            errors={formState.errors}
            setValue={setValue}
            watch={watch}
            operation={operation}
            getValues={getValues}
          />
        </Col>
      </Row>
      <Row>
        <Col span={16} offset={4}>
          <div style={{ textAlign: "center" }}>
            <Button
              disabled
              onClick={() => history.push("/onboarding/dashboard")}
            >
              Go to Dashboard
            </Button>
            <ButtonPrimary
              loading={updatingApproveCustomer}
              onClick={handleSubmit(formSubmit)}
            >
              Approve HMG
            </ButtonPrimary>
          </div>
        </Col>
      </Row>
    </CardElement>
  );
};

export default CustomerContainer;
